import { ServerApi } from 'modules/api/server-api';

export const candidateStopSuperSearch = (api: ServerApi) => async () => {
  return api.post('/v3/candidate/search-session/stop');
};
